/**
 * Created by hernanherreros on 2019-06-26
 */

import * as React from 'react'
import Content from '../../components/Layout/Content'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import { flowRight } from 'lodash'
import styled from 'styled-components'
import { getQuestions, getAnswers } from '../../requests/feedback'
import { getUUID } from '../../helpers/general'
import QuestionCard from '../../components/Feedback/QuestionCard'
import Question from '../../components/Feedback/Question'
import { Col, Icon, Row } from 'antd'
import { Route, RouteComponentProps, Switch } from 'react-router'
import Layout from '../../routers/RootRouter'
import { Link } from 'react-router-dom'

interface State {
  questions: any,
  answers: any,
  isLoading: boolean,
  isCompleted: boolean,
  currentQuestion?: string | null,
}

class FeedbackForm extends React.Component<ComponentProps & RouteComponentProps<{ uuid: string }>, State> {
  state = {
    questions: [],
    answers: [],
    isLoading: true,
    isCompleted: false,
    currentQuestion: null,
  }

  async componentWillMount () {
    await this.loadData()
    await this.loadAnswers()
  }

  loadData = async () => {
    this.setState({ isLoading: true })

    try {
      const questions = await getQuestions()

      this.setState({ questions: questions.Data })
    } catch (e) {
      console.log('FeedbackPage.loadData', e)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  getUserEmail = () => {
    let sessionID = localStorage.getItem('sessionID')

    if (!sessionID) {
      sessionID = getUUID()
      localStorage.setItem('sessionID', sessionID)
    }
    return sessionID + '@anonymous.com'
  }

  loadAnswers = async () => {

    this.setState({ isLoading: true })

    try {
      const answers = await getAnswers({ Email: this.getUserEmail() })
      this.setState({ answers: answers.Data })
    } catch (e) {
      console.log('FeedbackPage.loadAnswers', e)
    } finally {
      this.setState({ isLoading: false })
    }
  }

  setAsCompleted = () => {
    this.setState({ isCompleted: true })
  }

  handleAnswerSuccess = (questionUUID: string) => {
    const { questions } = this.state
    const { history, congress } = this.props
    const questionIndex = questions.findIndex((q: any) => q.UUID === questionUUID)
    const hasNext = (questionIndex + 1) < questions.length

    if (hasNext) {
      const nextQuestion: any = questions[questionIndex + 1]
      history.push(`/${congress.Slug}/feedback/${nextQuestion.UUID}`)
    } else {
      history.push(`/${congress.Slug}/feedback`)
    }
  }

  render () {
    const { isLoading } = this.state

    return (
      <Content>
        <Text>Valoramos tus comentarios. Por favor, responde las siguientes preguntas.</Text>
        {isLoading && <Icon type="loading" style={{ margin: '0 auto', display: 'block', fontSize: 30 }}/>}

        <Switch>
          <Route path="/:congressSlug/feedback/:uuid" render={this.renderQuestionForm}/>
          <Route path="/:congressSlug/feedback" render={this.renderQuestions}/>
        </Switch>
      </Content>
    )
  }

  renderQuestions = () => {
    const { questions, isLoading, answers } = this.state

    if (isLoading) {
      return null
    }

    return questions.map((q: any, i: number) => {
      const hasAnswer = !!(answers.find((a: any) => a.QuestionUUID === q.UUID))

      return (
        <QuestionCard
          title={q.Title}
          uuid={q.UUID}
          completed={hasAnswer}
        />
      )
    })
  }

  renderQuestionForm = () => {
    const { questions, isLoading } = this.state
    const { match, congress } = this.props

    if (isLoading) {
      return null
    }

    const question: any = questions.find((q: any) => q.UUID === match.params.uuid) || {}
    return (
      <Row type="flex" justify="center">
        <Col xs={24} md={18}>
          <Link to={`/${congress.Slug}/feedback`}><Icon type="left" /> Atrás</Link>
          <Question
            key={question ? question.UUID : undefined}
            question={question}
            email={this.getUserEmail()}
            onSuccess={this.handleAnswerSuccess}
          />
        </Col>
      </Row>
    )
  }
}

export default flowRight([withCongress])(FeedbackForm)

const Text = styled.p`
  font-size: 17px;
  text-align: center;
  margin-bottom: 30px;
`
